import React from 'react';

export default function ParsedUrl({ url }) {
  const parseUrl = urlValue => {
    try {
      return new URL(urlValue);
    } catch (e) {
      return urlValue;
    }
  }

  const parsed = parseUrl(url);
  if (typeof parsed !== 'string') {
    return (
      <React.Fragment>
        <span className="url__hostname">{parsed.hostname}</span>
        <span className="url__port">{parsed.port && ':'}{parsed.port}</span>
        <span className="url__path">{parsed.pathname === '/' ? '' : parsed.pathname}</span>
        <span className="url__hash">{parsed.hash}</span>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {parsed}
    </React.Fragment>
  )
}
